import React from 'react'
import MarkOne from '@icons/mark1.inline.svg'
import MarkTwo from '@icons/mark2.inline.svg'
import MarkThree from '@icons/mark3.inline.svg'

export interface ILink {
  name: string
  href: string
  targetBlank?: boolean
}

export interface IMark extends Omit<ILink, 'name'> {
  icon: React.ReactNode
}

export const links: ILink[][] = [
  [
    {name: 'О фонде', href: 'https://npfsberbanka.ru/about/'},
    {name: 'О работе фонда', href: 'https://npfsberbanka.ru/about/'},
    {name: 'Фонд в цифрах', href: 'https://npfsberbanka.ru/about/#found-number'},
    {name: 'Награды', href: 'https://npfsberbanka.ru/about/#awards'},
    {name: 'Руководство', href: 'https://npfsberbanka.ru/about/#management'},
  ], [
    {name: 'Сервисы', href: 'https://npfsberbanka.ru/services/'},
    {name: 'Оформить заявление правопреемника', href: 'https://lk.npfsb.ru/forms/successor/'},
    {name: 'Узнать статус заявления правопреемника', href: 'https://npfsberbanka.ru/successors/'},
    {name: 'Оформить пенсионный план', href: 'https://npo.npfsb.ru/'},
    {name: 'Личный кабинет клиента', href: 'https://lk.npfsb.ru/'},
  ], [
    {name: 'Частным клиентам', href: 'https://npfsberbanka.ru/ipp/'},
    {name: 'Индивидуальные пенсионные планы', href: 'https://npfsberbanka.ru/ipp/'},
    {name: 'Обязательное пенсионное страхование', href: 'https://npfsberbanka.ru/ops/'},
    {name: 'Документы', href: 'https://npfsberbanka.ru/about/information-to-be-disclosed/#files'},
    {name: 'Вопросы и ответы', href: 'https://npfsberbanka.ru/faq/'},
  ]
]

export const primaryLinks: ILink[] = [
  {name: 'Раскрытие информации', href: 'https://npfsberbanka.ru/about/information-to-be-disclosed/'},
  {name: 'Информация для потребителей финансовых услуг', href: 'https://npfsberbanka.ru/about/%D1%81onsumer_information/'},
  {name: 'Рекомендации по защите информации', href: 'https://npfsberbanka.ru/upload/safety_recommendations.pdf'},
  {name: 'Инвестиционная деятельность', href: 'https://npfsberbanka.ru/about/#investment'},
]

export const marks: IMark[] = [
  {
    icon: <MarkOne />,
    href: 'http://www.asv.org.ru/',
  },
  {
    icon: <MarkTwo />,
    href: 'https://npfsberbanka.ru/news/17891/',
  },
  {
    icon: <MarkThree />,
    href: 'http://napf.ru/',
  }
]

export const copyright = '© 2009–2021 Акционерное общество «Негосударственный Пенсионный Фонд Сбербанка» Лицензия №41/2 от 16.06.2009 г.выдана Федеральной службой по финансовым рынкам ИНН/ КПП 7725352740/772501001, ОГРН 1147799009160'